export const pages = {
    contacto: "contacto",
    unidades: "unidades",
    pagos: "pagos",
    usuarios: "usuarios",
    asistencia: "asistencia"
}

export const tipoActividadVulnerable = [
    {id: 1, riesgo: "medio-bajo",name: "Derechos Personales de Uso o Goce de Inmuebles (Arrendamiento)"},
    {id: 2, riesgo: "medio-bajo",name: "Transmisión de Derechos Sobre Bienes Inmuebles (Intermediación / Compraventa)"},
    {id: 3, riesgo: "medio", name: "Mutuo, Préstamo o Créditos"},
    {id: 4, riesgo: "medio-bajo", name: "Servicios Profesionales Independientes"},
    {id: 5, riesgo: "medio-bajo", name: "Desarrollo Inmobiliario", value: "desarrollo_inmobiliario"},
    {id: 6, riesgo: "medio-bajo",name: "Recepción de Donativos"},
    {id: 7, riesgo: "medio",name: "Vehículos Aéreos, Marítimos o Terrestres"},
    {id: 8, riesgo: "medio", name: "Fe Pública", value: "fe_publica"},
    {id: 9, riesgo: "alto", name: "Metales, Piedras Preciosas, Joyas o Relojes"},
    {id: 10, riesgo: "bajo",name: "Servicios de Comercio Exterior"},
    {id: 11, riesgo: "medio", name: "Tarjetas Prepagadas, Vales o Cupones"},
    {id: 12, riesgo: "alto", name: "Obras de Arte"},
    {id: 13, riesgo: "medio-bajo", name: "Juegos con Apuesta, Concursos o Sorteos"},
    {id: 14, riesgo: "medio-bajo",name: "Tarjetas de Servicios o De Crédito"},
    {id: 15, riesgo: "medio-bajo", name: "Traslado o Custodia de Dinero o Valores"},
    {id: 16, riesgo: "medio-bajo", name: "Servicios de Blindaje"},
    {id: 17, riesgo: "medio", name: "Servidores Públicos"},
    {id: 18, riesgo: "medio-bajo", name: "Operaciones con Activos Virtuales"},
    {id: 19, riesgo: "alto",name: "Monederos y Certificados de Devoluciones o Recompensas"},
    {id: 20, riesgo: "bajo", name: "Cheques de Viajero"}
]

export const evaluacionRiesgoInherente = [
    {
        pilar: 'A',
        titulo: 'Pilar A: Actos u Operaciones (Peso: 30%)',
        preguntas: [
            {
                id: 'pilarA_volumen',
                texto: '¿Cuál es el volumen transaccional y los montos operados habitualmente por la entidad?',
                opciones: [
                    { value: 1, etiqueta: 'Bajo (1 pt): Operaciones con montos pequeños que rara vez o nunca alcanzan los umbrales de aviso.' },
                    { value: 2, etiqueta: 'Medio (2 pts): Operaciones promedio de valor moderado que frecuentemente superan los umbrales de identificación.' },
                    { value: 3, etiqueta: 'Alto (3 pts): Créditos, mutuos, desarrollos inmobiliarios o transacciones de alto valor constante (ej. operaciones > $50M MXN).' }
                ]
            },
            {
                id: 'pilarA_naturaleza',
                texto: '¿Cuál es la naturaleza y complejidad del servicio prestado?',
                opciones: [
                    { value: 1, etiqueta: 'Bajo (1 pt): Servicios estándar de bajo riesgo (ej. avalúos, arrendamiento habitacional de interés social).' },
                    { value: 2, etiqueta: 'Medio (2 pts): Servicios de mediana complejidad (ej. cesión de acciones, aumentos de capital, arrendamiento comercial).' },
                    { value: 3, etiqueta: 'Alto (3 pts): Servicios de alta vulnerabilidad (ej. constitución de holding corporativo, fideicomisos complejos, servicios de activos virtuales/PSAVI).' }
                ]
            }
        ]
    },
    {
        pilar: 'B',
        titulo: 'Pilar B: Tipo de Personas Clientes o Usuarios (Peso: 30%)',
        preguntas: [
            {
                id: 'pilarB_estructura',
                texto: '¿Cuál es la estructura jurídica predominante de sus clientes o deudores?',
                opciones: [
                    { value: 1, etiqueta: 'Bajo (1 pt): Principalmente personas físicas nacionales.' },
                    { value: 2, etiqueta: 'Medio (2 pts): Personas morales mexicanas tradicionales (S.A., S.A.P.I.) con Beneficiario Controlador claramente identificado.' },
                    { value: 3, etiqueta: 'Alto (3 pts): Personas morales extranjeras, holdings multinivel, estructuras fideicomitidas u opacidad en la composición accionaria.' }
                ]
            },
            {
                id: 'pilarB_clientesRiesgo',
                texto: '¿La entidad atiende a clientes con condiciones especiales de riesgo (PEP o no residentes)?',
                opciones: [
                    { value: 1, etiqueta: 'Bajo (1 pt): 0% de clientes PEPs o extranjeros no residentes.' },
                    { value: 2, etiqueta: 'Medio (2 pts): Presencia ocasional de Personas Políticamente Expuestas (PEP) nacionales.' },
                    { value: 3, etiqueta: 'Alto (3 pts): Operación habitual con PEPs extranjeras o clientes ubicados en jurisdicciones de régimen fiscal preferente o listas GAFI.' }
                ]
            }
        ]
    },
    {
        pilar: 'C',
        titulo: 'Pilar C: Países y Áreas Geográficas (Peso: 20%)',
        preguntas: [
            {
                id: 'pilarC_ubicacion',
                texto: '¿En qué ubicación geográfica se encuentran los clientes o se ejecutan los servicios?',
                opciones: [
                    { value: 1, etiqueta: 'Bajo (1 pt): Operación comercial local en la misma jurisdicción de la entidad.' },
                    { value: 2, etiqueta: 'Medio (2 pts): Operación comercial multiestado en México en zonas sin alerta específica.' },
                    { value: 3, etiqueta: 'Alto (3 pts): Operaciones en estados identificados con alta vulnerabilidad en la ENR 2023, zonas fronterizas o transacciones con destino al extranjero.' }
                ]
            }
        ]
    },
    {
        pilar: 'D',
        titulo: 'Pilar D: Canales de Distribución e Instrumentos Monetarios (Peso: 20%)',
        preguntas: [
            {
                id: 'pilarD_relacion',
                texto: '¿Cómo se establece la relación comercial y la firma de actos?',
                opciones: [
                    { value: 1, etiqueta: 'Bajo (1 pt): Identificación y firma de contratos presencial cara a cara.' },
                    { value: 2, etiqueta: 'Medio (2 pts): Contratación a través de apoderados, comisionistas o gestores.' },
                    { value: 3, etiqueta: 'Alto (3 pts): Onboarding 100% remoto digital sin presencia física.' }
                ]
            },
            {
                id: 'pilarD_instrumentos',
                texto: '¿Qué instrumentos monetarios se utilizan para la liquidación de las operaciones?',
                opciones: [
                    { value: 1, etiqueta: 'Bajo (1 pt): 100% bancarizado mediante transferencias electrónicas (SPEI) o cheques nominativos.' },
                    { value: 2, etiqueta: 'Medio (2 pts): Uso ocasional de efectivo dentro de los límites legales permitidos.' },
                    { value: 3, etiqueta: 'Alto (3 pts): Operaciones con activos virtuales, divisas extranjeras o intentos de pago en efectivo sobrepasando límites.' }
                ]
            }
        ]
    }
]

export const evaluacionMitigantes = [
    {
        id: 'manualPoliticas',
        titulo: 'Manual de Políticas Internas (Capítulo X - Art. 37 Bis)',
        texto: '¿Cuenta con su Manual de Políticas con las 14 secciones mínimas y la metodología EBR por escrito?',
        ayuda: 'Puntuación: 100% si está completo y vigente; 50% si está incompleto o desactualizado; 0% si no existe.',
        opciones: [
            { value: 100, etiqueta: '100% — Completo y vigente' },
            { value: 50, etiqueta: '50% — Incompleto o desactualizado' },
            { value: 0, etiqueta: '0% — No existe' }
        ]
    },
    {
        id: 'rec',
        titulo: 'Representante Encargada de Cumplimiento - REC (Art. 20 Ley / Art. 10 RCG)',
        texto: '¿Tiene designada a una persona física como REC con e.firma activa registrada ante el Portal del SPPLD/SAT?',
        ayuda: 'Puntuación: 100% si está registrado con e.firma; 0% si no hay designación oficial.',
        opciones: [
            { value: 100, etiqueta: '100% — Registrado con e.firma' },
            { value: 0, etiqueta: '0% — Sin designación oficial' }
        ]
    },
    {
        id: 'softwarePLD',
        titulo: 'Mecanismos Automatizados y Software PLD (Capítulo XIII - Art. 41)',
        texto: '¿Utiliza una herramienta tecnológica que agrupe operaciones, calcule scoring, ejecute el motor Q-Detect contra listas de la UIF/SAT/ONU, acumule transacciones a 6 meses y resguarde expedientes por 10 años?',
        ayuda: 'Puntuación: 100% software PLD especializado; 50% hojas de cálculo parciales sin listas; 0% registros manuales en papel.',
        opciones: [
            { value: 100, etiqueta: '100% — Software PLD especializado' },
            { value: 50, etiqueta: '50% — Hojas de cálculo parciales sin listas' },
            { value: 0, etiqueta: '0% — Registros manuales en papel' }
        ]
    },
    {
        id: 'capacitacion',
        titulo: 'Programa de Capacitación Anual (Capítulo XII - Art. 39 Bis)',
        texto: '¿Se imparten cursos al menos una vez al año al personal, con evaluaciones y constancias conservadas por 10 años?',
        ayuda: 'Puntuación: 100% programa anual acreditable y evaluable; 0% sin capacitaciones.',
        opciones: [
            { value: 100, etiqueta: '100% — Programa anual acreditable y evaluable' },
            { value: 0, etiqueta: '0% — Sin capacitaciones' }
        ]
    },
    {
        id: 'seleccionPersonal',
        titulo: 'Procedimientos de Selección de Personal (Art. 39 Bis 2)',
        texto: '¿Se solicita a cada empleado una declaración firmada de no haber sido sentenciado por delitos patrimoniales ni inhabilitado?',
        ayuda: 'Puntuación: 100% si se recaban las declaraciones; 0% si no existen antecedentes de selección.',
        opciones: [
            { value: 100, etiqueta: '100% — Se recaban las declaraciones' },
            { value: 0, etiqueta: '0% — Sin antecedentes de selección' }
        ]
    },
    {
        id: 'auditoria',
        titulo: 'Auditoría e Inspección Interna / Externa (Capítulo XIV - Art. 42)',
        texto: '¿Se efectúa una revisión anual que evalúe y emita un dictamen de efectividad sobre el programa de cumplimiento?',
        ayuda: 'Puntuación: 100% si cuenta con dictamen anual; 0% si no se audita.',
        opciones: [
            { value: 100, etiqueta: '100% — Cuenta con dictamen anual' },
            { value: 0, etiqueta: '0% — No se audita' }
        ]
    }
]

export function crearEstadoRiesgoInherente() {
    const estado = {}
    evaluacionRiesgoInherente.forEach((pilar) => {
        pilar.preguntas.forEach((pregunta) => {
            estado[pregunta.id] = ''
        })
    })
    return estado
}

export function crearEstadoMitigantes() {
    const estado = {}
    evaluacionMitigantes.forEach((item) => {
        estado[item.id] = ''
    })
    return estado
}

export const pesosPilares = { A: 0.30, B: 0.30, C: 0.20, D: 0.20 }

export const UMBRAL_RIESGO_RESIDUAL_BAJO = 1.20

function promedioPilar(pilar, respuestas) {
    const valores = pilar.preguntas.map((pregunta) => {
        const valor = respuestas[pregunta.id]
        if (valor === '' || valor === undefined) {
            return null
        }
        return Number(valor)
    })
    if (valores.some((v) => v === null)) {
        return null
    }
    return valores.reduce((suma, valor) => suma + valor, 0) / valores.length
}

export function calcularRiesgoInherenteConsolidado(respuestas) {
    let consolidado = 0
    for (const pilar of evaluacionRiesgoInherente) {
        const promedio = promedioPilar(pilar, respuestas)
        if (promedio === null) {
            return null
        }
        consolidado += pesosPilares[pilar.pilar] * promedio
    }
    return consolidado
}

export function calcularPromedioEficaciaControles(mitigantes) {
    const valores = evaluacionMitigantes.map((item) => {
        const valor = mitigantes[item.id]
        if (valor === '' || valor === undefined) {
            return null
        }
        return Number(valor)
    })
    if (valores.some((v) => v === null)) {
        return null
    }
    return valores.reduce((suma, valor) => suma + valor, 0) / valores.length
}

export function calcularRiesgoResidualInstitucional(riesgoInherenteConsolidado, promedioEficaciaControlesPct) {
    if (riesgoInherenteConsolidado === null || promedioEficaciaControlesPct === null) {
        return null
    }
    const eficacia = promedioEficaciaControlesPct / 100
    return riesgoInherenteConsolidado * (1 - eficacia)
}

export function diagnosticarRiesgoResidual(riesgoResidual) {
    if (riesgoResidual === null) {
        return null
    }
    if (riesgoResidual < UMBRAL_RIESGO_RESIDUAL_BAJO) {
        return {
            nivel: 'BAJO',
            descripcion: 'Otorga a la entidad la prerrogativa de emitir su dictamen de auditoría anual obligatoria mediante su propia área de control o auditoría interna (evitando el costo de auditores externos certificados) y aplicar medidas de identificación simplificadas a clientes individuales de bajo riesgo.'
        }
    }
    return {
        nivel: 'MEDIO / ALTO',
        descripcion: 'Exige contratar obligatoriamente a un auditor externo independiente certificado por la UIF para el dictamen anual y aplicar medidas de debida diligencia reforzada (EDD).'
    }
}

export function formatearPuntaje(valor) {
    if (valor === null || Number.isNaN(valor)) {
        return '—'
    }
    return valor.toFixed(2)
}

// ---------------------------------------------------------------------------
// Catálogos con metadatos de esquema para persistencia en RespuestaCuestionario
// ---------------------------------------------------------------------------

const pesoUnitarioMitigante = (1 / evaluacionMitigantes.length).toFixed(4)

export const catalogoRiesgoInherente = evaluacionRiesgoInherente.flatMap((pilar) =>
    pilar.preguntas.map((pregunta) => ({
        id: pregunta.id,
        dimension: pilar.pilar,
        pregunta: pregunta.texto,
        opciones: pregunta.opciones,
        tipo: 'riesgo_inherente',
        scoring: '1-3',
        peso_default: String(pesosPilares[pilar.pilar]),
        criticidad: 'alta',
    }))
)

export const catalogoMitigantes = evaluacionMitigantes.map((item) => ({
    id: item.id,
    dimension: 'mitigantes',
    pregunta: item.texto,
    titulo: item.titulo,
    ayuda: item.ayuda,
    opciones: item.opciones,
    tipo: 'mitigante',
    scoring: 'eficacia_pct',
    peso_default: pesoUnitarioMitigante,
    criticidad: 'alta',
}))

// ---------------------------------------------------------------------------
// Helpers para construir el payload con formato del esquema de persistencia
// ---------------------------------------------------------------------------

export function buildRespuestasRiesgoInherente(riesgoInherenteState) {
    return catalogoRiesgoInherente.map((item) => ({
        id: item.id,
        dimension: item.dimension,
        pregunta: item.pregunta,
        tipo: item.tipo,
        scoring: item.scoring,
        peso_default: item.peso_default,
        criticidad: item.criticidad,
        respuesta: riesgoInherenteState[item.id] !== undefined ? riesgoInherenteState[item.id] : null,
    }))
}

export function buildRespuestasMitigantes(mitigantesState) {
    return catalogoMitigantes.map((item) => ({
        id: item.id,
        dimension: item.dimension,
        pregunta: item.pregunta,
        tipo: item.tipo,
        scoring: item.scoring,
        peso_default: item.peso_default,
        criticidad: item.criticidad,
        respuesta: mitigantesState[item.id] !== undefined ? mitigantesState[item.id] : null,
    }))
}

export function buildPayloadCuestionario({ actividadVulnerable, unidadId, riesgoInherenteState, mitigantesState }) {
    return {
        actividad_vulnerable: actividadVulnerable,
        unidad: unidadId,
        cuestionario: buildRespuestasRiesgoInherente(riesgoInherenteState),
        mitigantes: buildRespuestasMitigantes(mitigantesState),
    }
}
